import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('../layouts/LandingLayout.vue'),
    meta: {
      title: '',
      requiresAuth: false,
    },
    children: [
      {
        name: 'LandingPage',
        path: '',
        meta: {
          title: '',
          requiresAuth: false,
        },
        component: () => import('../pages/landing/HomePageNew.vue'),
      },
      // {
      //   name: 'PublicNewsAndEvents',
      //   path: 'news-&-events',
      //   meta: {
      //     title: 'PublicNewsAndEvents',
      //   },
      //   component: () =>
      //     import('../components/landing-page/news-and-events/PublicNewsAndEvents.vue'),
      // },
      {
        name: 'PublicNews',
        path: 'public-news',
        meta: {
          title: 'Public News',
        },
        component: () => import('../components/landing-page/news-and-events/PublicNews.vue'),
      },
      {
        name: 'PublicEvents',
        path: 'public-events',
        meta: {
          title: 'Public Events',
        },
        component: () => import('../components/landing-page/news-and-events/PublicEvents.vue'),
      },
      {
        name: 'OverviewNews',
        path: '/public-news/overview/:id',
        meta: {
          title: 'Overview News',
        },
        component: () => import('../components/landing-page/news-and-events/OverviewNews.vue'),
      },
      {
        name: 'OverviewEvents',
        path: '/public-events/overview/:id',
        meta: {
          title: 'Overview Events',
        },
        component: () => import('../components/landing-page/news-and-events/OverviewEvents.vue'),
      },
      {
        name: 'Banner',
        path: 'banner',
        meta: {
          title: 'Banner',
        },
        component: () => import('../components/landing-page/Banner.vue'),
      },
      {
        name: 'About',
        path: 'about',
        meta: {
          title: 'About',
        },
        component: () => import('../components/landing-page/About.vue'),
      },
      {
        name: 'HowItWorks',
        path: 'how-it-works',
        meta: {
          title: 'HowItWorks',
        },
        component: () => import('../components/landing-page/HowItWorks.vue'),
      },
      {
        name: 'Help',
        path: 'help',
        meta: {
          title: 'Help',
        },
        component: () => import('../components/help/Help'),
      },
      {
        name: 'PrivacyPolicy',
        path: 'privacy-policy',
        meta: {
          title: 'PrivacyPolicy',
        },
        component: () => import('../components/landing-page/PrivacyPolicy.vue'),
      },
      {
        name: 'Tutorials',
        path: 'tutorials',
        meta: {
          title: 'Tutorials',
        },
        component: () => import('../components/landing-page/Tutorials.vue'),
      },
      {
        name: 'HostingInstitution',
        path: 'hosting-institutions',
        meta: {
          title: 'HostingInstitution',
        },
        component: () => import('../components/landing-page/HostingInstitution.vue'),
      },
      {
        name: 'PublicSearchMarketplace',
        path: 'public-search-marketplace',
        meta: {
          title: 'Search Marketplace',
          requiresAuth: false,
        },
        component: () => import('../components/marketplace/PublicSearchMarketplace.vue'),
      },
      // {
      //   path: '/public-marketplace',
      //   component: () => import('../views/PublicMarketplace.vue'),
      //   meta: {
      //     requiresAuth: false,
      //   },
      //   children: [
      //     {
      //       name: 'PublicMarketplace',
      //       path: 'marketplace',
      //       meta: {
      //         title: 'Catalogue & Marketplace',
      //         breadcrumbPath: [
      //           {
      //             text: 'Catalogue & Marketplace',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplace',
      //             },
      //           },
      //         ],
      //         requiresAuth: false,
      //       },
      //       component: () => import('../components/marketplace/Marketplace.vue'),
      //     },
      //     {
      //       name: 'PublicMarketplaceGeneralSearch',
      //       path: 'marketplace/general-search',
      //       meta: {
      //         title: 'Catalogue & Marketplace',
      //         breadcrumbPath: [
      //           {
      //             text: 'Catalogue & Marketplace',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplace',
      //             },
      //           },
      //         ],
      //         requiresAuth: false,
      //       },
      //       component: () => import('../components/marketplace/MarketplaceGeneralSearch.vue'),
      //     },
      //     {
      //       name: 'PublicMarketplaceGeneralSearchProvider',
      //       path: 'marketplace/general-search-provider',
      //       meta: {
      //         title: 'Catalogue & Marketplace',
      //         breadcrumbPath: [
      //           {
      //             text: 'Catalogue & Marketplace',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplace',
      //             },
      //           },
      //         ],
      //         requiresAuth: false,
      //       },
      //       component: () =>
      //         import('../components/marketplace/MarketplaceGeneralSearchProvider.vue'),
      //     },
      //     {
      //       name: 'PublicMarketplaceService',
      //       path: 'marketplace/services/:id',
      //       meta: {
      //         title: 'Services',
      //         breadcrumbPath: [
      //           {
      //             text: 'Catalogue & Marketplace',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplace',
      //             },
      //           },
      //           {
      //             text: 'Services',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplaceServices',
      //             },
      //           },
      //           {
      //             text: 'Service Name',
      //           },
      //         ],
      //         requiresAuth: false,
      //       },
      //       component: () => import('../components/marketplace/MarketplaceResource.vue'),
      //     },
      //     {
      //       name: 'PublicMarketplaceServices',
      //       path: 'marketplace/services',
      //       meta: {
      //         title: 'Services',
      //         breadcrumbPath: [
      //           {
      //             text: 'Catalogue & Marketplace',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplace',
      //             },
      //           },
      //           {
      //             text: 'Services',
      //           },
      //         ],
      //         requiresAuth: false,
      //       },
      //       component: () => import('../components/marketplace/MarketplaceResources.vue'),
      //     },
      //     {
      //       name: 'PublicMarketplaceProviders',
      //       path: 'marketplace/providers',
      //       meta: {
      //         title: 'Providers',
      //         breadcrumbPath: [
      //           {
      //             text: 'Catalogue & Marketplace',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplace',
      //             },
      //           },
      //           {
      //             text: 'Providers',
      //           },
      //         ],
      //         requiresAuth: false,
      //       },
      //       component: () => import('../components/marketplace/MarketplaceProviders.vue'),
      //     },
      //     {
      //       name: 'PublicMarketplaceProvider',
      //       path: 'marketplace/providers/:id',
      //       meta: {
      //         title: 'Providers',
      //         breadcrumbPath: [
      //           {
      //             text: 'Catalogue & Marketplace',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplace',
      //             },
      //           },
      //           {
      //             text: 'Providers',
      //             exact: true,
      //             to: {
      //               name: 'PublicMarketplaceProviders',
      //             },
      //           },
      //           {
      //             text: 'Provider Name',
      //           },
      //         ],
      //         requiresAuth: false,
      //       },
      //       component: () => import('../components/marketplace/MarketplaceProvider.vue'),
      //     },
      //   ],
      // },
      {
        name: 'PublicCatalogueAndMarketplace',
        path: 'public-catalogue-marketplace',
        meta: { title: 'Catalogue & Marketplace' },
        component: () => import('../components/marketplace/PublicCatalogueAndMarketplace.vue'),
        children: [
          {
            name: 'BrowseCatalogueServices',
            path: 'services',
            component: () => import('../components/marketplace/BrowseCatalogueServices.vue'),
          },
          {
            name: 'BrowseCatalogueProviders',
            path: 'providers',
            component: () => import('../components/marketplace/BrowseCatalogueProviders.vue'),
          },
          {
            name: 'BrowseCatalogueEquipment',
            path: 'equipment',
            component: () => import('../components/marketplace/BrowseCatalogueEquipment.vue'),
          },
          {
            name: 'BrowseCataloguePatents',
            path: 'patents',
            component: () => import('../components/marketplace/BrowseCataloguePatents.vue'),
          },
          {
            name: 'BrowseCatalogueHostingInstitutions',
            path: 'hosting-institutions',
            component: () =>
              import('../components/marketplace/BrowseCatalogueHostingInstitutions.vue'),
          },
        ],
      },
      {
        name: 'PublicOverviewEquipment',
        path: 'public-equipment/overview/:id',
        meta: {
          title: 'Overview Equipment',
        },
        component: () => import('../components/equipment/PublicOverviewEquipment.vue'),
      },
      {
        name: 'PublicOverviewPatent',
        path: 'public-patent/overview/:id',
        meta: {
          title: 'Overview Patent',
        },
        component: () => import('../components/patents/PublicOverviewPatent.vue'),
      },
      {
        name: 'PublicOverviewService',
        path: 'public-service/overview/:id',
        meta: {
          title: 'Overview Service',
        },
        component: () => import('../components/resource/PublicOverviewService.vue'),
      },
      {
        name: 'PublicOverviewProvider',
        path: 'public-provider/overview/:id',
        meta: {
          title: 'Overview Provider',
        },
        component: () => import('../components/provider/PublicOverviewProvider.vue'),
      },
      {
        name: 'PublicOverviewHostingInstitution',
        path: 'public-hosting-institution/overview/:id',
        meta: {
          title: 'Overview Hosting Institution',
        },
        component: () =>
          import('../components/hosting-institution/PublicOverviewHostingInstitution.vue'),
      },
    ],
  },
  {
    path: '/provider',
    component: () => import('../layouts/ProviderLayout.vue'),
    meta: {
      title: '',
      requiresAuth: true,
    },
    children: [
      {
        name: 'ProviderSettings',
        path: 'settings',
        meta: {
          title: 'Provider Settings',
          requiresAuth: true,
          authorize: ['provider'],
          breadcrumbPath: [
            {
              text: 'Provider Settings',
              disabled: true,
              exact: true,
              to: {
                name: 'ProviderSettings',
              },
            },
          ],
        },
        component: () => import('../components/provider-settings/ProviderSettings.vue'),
      },
    ],
  },
  {
    path: '/app',
    component: () => import('../layouts/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        name: 'Profile',
        path: 'profile',
        meta: {
          title: 'Profile',
          requiresAuth: true,
          authorize: ['researcher', 'super-admin'],
        },
        component: () => import('../components/profile/Profile.vue'),
      },
      {
        name: 'ProfileProvider',
        path: 'profile-provider',
        meta: {
          title: 'ProfileProvider',
          requiresAuth: true,
          authorize: ['provider'],
        },
        component: () => import('../components/profile/ProfileProvider.vue'),
      },
      {
        name: 'Dashboard',
        path: 'dashboard',
        meta: {
          title: 'Dashboard',
          requiresAuth: true,
          authorize: ['provider', 'super-admin', 'institution-representative'],
        },
        component: () => import('../pages/dashboard/DashboardPage.vue'),
      },
      {
        name: 'Marketplace',
        path: '/marketplace',
        meta: {
          title: 'Catalogue & Marketplace',
          requiresAuth: true,
          authorize: ['provider', 'researcher', 'super-admin', 'institution-representative'],
        },
        component: () => import('../components/marketplace/Marketplace.vue'),
        children: [
          {
            name: 'BrowseCatalogueServices',
            path: 'services',
            component: () => import('../components/marketplace/BrowseCatalogueServices.vue'),
          },
          {
            name: 'BrowseCatalogueProviders',
            path: 'providers',
            component: () => import('../components/marketplace/BrowseCatalogueProviders.vue'),
          },
          {
            name: 'BrowseCatalogueEquipment',
            path: 'equipment',
            component: () => import('../components/marketplace/BrowseCatalogueEquipment.vue'),
          },
          {
            name: 'BrowseCataloguePatents',
            path: 'patents',
            component: () => import('../components/marketplace/BrowseCataloguePatents.vue'),
          },
          {
            name: 'BrowseCatalogueHostingInstitutions',
            path: 'hosting-institutions',
            component: () =>
              import('../components/marketplace/BrowseCatalogueHostingInstitutions.vue'),
          },
        ],
      },
      {
        name: 'MarketplaceGeneralSearch',
        path: 'marketplace/general-search',
        meta: {
          title: 'Marketplace',
          requiresAuth: true,
          authorize: ['provider', 'researcher', 'super-admin'],
        },
        component: () => import('../components/marketplace/MarketplaceGeneralSearch.vue'),
      },
      {
        name: 'SearchMarketplace',
        path: 'search-marketplace',
        meta: {
          title: 'Search Marketplace',
          requiresAuth: true,
          authorize: ['provider', 'researcher', 'super-admin'],
        },
        component: () => import('../components/marketplace/SearchMarketplace.vue'),
      },
      {
        name: 'MarketplaceGeneralSearchProvider',
        path: 'marketplace/general-search-provider',
        meta: {
          title: 'Marketplace',
          requiresAuth: true,
          authorize: ['provider', 'researcher', 'super-admin'],
        },
        component: () => import('../components/marketplace/MarketplaceGeneralSearchProvider.vue'),
      },
      // {
      //   name: 'MarketplaceService',
      //   path: 'marketplace/services/:id',
      //   meta: {
      //     title: 'Marketplace Service',
      //     requiresAuth: true,
      //     authorize: ['provider', 'researcher', 'super-admin'],
      //     breadcrumbPath: [
      //       {
      //         text: 'Marketplace',
      //         exact: true,
      //         to: {
      //           name: 'Marketplace',
      //         },
      //       },
      //       {
      //         text: 'Services',
      //         exact: true,
      //         to: {
      //           name: 'MarketplaceServiceIsNotEquipment',
      //         },
      //       },
      //       {
      //         text: 'Service Name',
      //       },
      //     ],
      //   },
      //   component: () => import('../components/marketplace/MarketplaceResource.vue'),
      // },
      // {
      //   name: 'MarketplaceServiceIsNotEquipment',
      //   path: 'marketplace/services-is-not-equipment',
      //   redirect: () => {
      //     // the function receives the target route as the argument
      //     // we return a redirect path/location here.
      //     return { name: 'MarketplaceServices' };
      //   },
      // },
      // {
      //   name: 'MarketplaceServices',
      //   path: 'marketplace/services',
      //   meta: {
      //     title: 'Marketplace Services',
      //     requiresAuth: true,
      //     authorize: ['provider', 'researcher', 'super-admin'],
      //     breadcrumbPath: [
      //       {
      //         text: 'Marketplace',
      //         exact: true,
      //         to: {
      //           name: 'Marketplace',
      //         },
      //       },
      //       {
      //         text: 'Services',
      //       },
      //     ],
      //   },
      //   component: () => import('../components/marketplace/MarketplaceResources.vue'),
      // },
      // {
      //   name: 'MarketplaceProviders',
      //   path: 'marketplace/providers',
      //   meta: {
      //     title: 'Marketplace Providers',
      //     requiresAuth: true,
      //     authorize: ['provider', 'researcher', 'super-admin'],
      //     breadcrumbPath: [
      //       {
      //         text: 'Marketplace',
      //         exact: true,
      //         to: {
      //           name: 'Marketplace',
      //         },
      //       },
      //       {
      //         text: 'Providers',
      //       },
      //     ],
      //   },
      //   component: () => import('../components/marketplace/MarketplaceProviders.vue'),
      // },
      // {
      //   name: 'MarketplaceProvider',
      //   path: 'marketplace/providers/:id',
      //   meta: {
      //     title: 'Marketplace Provider',
      //     requiresAuth: true,
      //     authorize: ['provider', 'researcher', 'super-admin'],
      //     breadcrumbPath: [
      //       {
      //         text: 'Marketplace',
      //         exact: true,
      //         to: {
      //           name: 'Marketplace',
      //         },
      //       },
      //       {
      //         text: 'Providers',
      //         exact: true,
      //         to: {
      //           name: 'MarketplaceProviders',
      //         },
      //       },
      //       {
      //         text: 'Provider Name',
      //       },
      //     ],
      //   },
      //   component: () => import('../components/marketplace/MarketplaceProvider.vue'),
      // },
      // {
      //   name: 'Providers',
      //   path: 'providers',
      //   meta: {
      //     title: 'Providers',
      //     requiresAuth: true,
      //     authorize: ['super-admin'],
      //   },
      //   component: () => import('../components/provider/Providers.vue'),
      // },
      {
        name: 'AdminProviders',
        path: 'all-providers',
        meta: {
          title: 'Providers',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/provider/AdminProviders.vue'),
      },
      {
        name: 'EditProvider',
        path: 'edit/:id',
        meta: {
          title: 'Provider Edit',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/provider/EditProvider.vue'),
      },
      {
        name: 'OverviewProvider',
        path: 'provider/overview/:id',
        meta: {
          title: 'Provider Overview',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/provider/OverviewProvider.vue'),
      },
      {
        name: 'EditAdminProviderMembers',
        path: 'all-providers/:id/members',
        meta: {
          title: 'EditAdminProviderMembers',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/provider-member/Members.vue'),
      },
      {
        name: 'Orders',
        path: 'orders',
        meta: {
          title: 'Orders',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/order/Orders.vue'),
      },
      {
        name: 'MyOrders',
        path: 'my-orders',
        meta: {
          title: 'My Orders',
          requiresAuth: true,
          authorize: ['researcher', 'provider', 'institution-representative'],
        },
        component: () => import('../components/order/MyOrders.vue'),
      },
      {
        name: 'Subscriptions',
        path: 'subscriptions',
        meta: {
          title: 'Subscriptions',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/Subscriptions.vue'),
      },
      {
        name: 'ProvidersOverview',
        path: 'providers-view/:id',
        meta: {
          title: 'Providers Overview',
          requiresAuth: true,
          authorize: ['super-admin'],
          breadcrumbPath: [
            {
              text: 'Providers',
              exact: true,
              to: {
                name: 'Providers',
              },
            },
            {
              text: 'Provider Name',
            },
          ],
        },
        component: () => import('../components/marketplace/MarketplaceProvider.vue'),
      },
      {
        name: 'Users',
        path: 'users',
        meta: {
          title: 'Users',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/users/Users.vue'),
      },
      {
        name: 'UserOverview',
        path: 'users/:id',
        meta: {
          title: 'User Overview',
          requiresAuth: true,
          authorize: ['super-admin'],
          breadcrumbPath: [
            {
              text: 'Users',
              exact: true,
              to: {
                name: 'Users',
              },
            },
            {
              text: 'User Name',
            },
          ],
        },
        component: () => import('../components/User.vue'),
      },
      {
        name: 'ControlValues',
        path: 'control-values',
        meta: {
          title: 'Control Values',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/control-values/ControlValues.vue'),
      },
      {
        name: 'NewsAndEvents',
        path: 'news-and-events',
        meta: {
          title: 'News & Events',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/news-events/NewsAndEvents.vue'),
      },
      {
        name: 'CreateNewsAndEvents',
        path: '/create-news-and-events',
        meta: {
          title: 'Create News & Events',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/news-events/CreateNewsAndEvents.vue'),
      },

      {
        name: 'EditNewsAndEvents',
        path: '/edit-news-and-events/:id',
        meta: {
          title: 'Edit News & Events',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/news-events/CreateNewsAndEvents.vue'),
      },
      {
        name: 'Campaign',
        path: 'campaign',
        meta: {
          title: 'Campaign',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/campaign/Campaign.vue'),
      },
      {
        name: 'EditCampaign',
        path: 'campaign/:id',
        meta: {
          title: 'Edit Campaign',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/campaign/EditCampaign.vue'),
      },
      {
        name: 'CreateCampaign',
        path: 'create-campaign',
        meta: {
          title: 'Create Campaign',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/campaign/CreateCampaign.vue'),
      },
      {
        name: 'AdminServices',
        path: 'all-services',
        meta: {
          title: 'Services',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/resources/Resources.vue'),
      },
      {
        name: 'AdminServicesEdit',
        path: 'all-services/edit',
        meta: {
          title: 'Services Edit',
          requiresAuth: true,
          authorize: ['super-admin'],
          // breadcrumbPath: [
          //   {
          //     text: 'Services',
          //     exact: true,
          //     to: {
          //       name: 'AdminServices',
          //     },
          //   },
          //   {
          //     text: 'Service Name',
          //   },
          // ],
        },
        component: () => import('../components/add-resource/ResourceSettings.vue'),
      },
      {
        name: 'AdminServicesOverview',
        path: 'all-services/:id',
        meta: {
          title: 'Service Overview',
          requiresAuth: true,
          authorize: ['super-admin'],
          breadcrumbPath: [
            {
              text: 'Services',
              exact: true,
              to: {
                name: 'AdminServices',
              },
            },
            {
              text: 'Service Name',
            },
          ],
        },
        component: () => import('../components/marketplace/MarketplaceResource.vue'),
      },
      {
        name: 'Members',
        path: 'members',
        meta: {
          title: 'Members',
          requiresAuth: true,
          authorize: ['provider'],
        },
        component: () => import('../components/provider-member/Members.vue'),
      },
      {
        name: 'MemberOverview',
        path: 'members/:id',
        meta: {
          title: 'Member Overview',
          requiresAuth: true,
          authorize: ['provider'],
        },
        component: () => import('../components/User.vue'),
      },
      {
        name: 'Services',
        path: 'services',
        meta: {
          title: 'Services',
          requiresAuth: true,
          authorize: ['provider'],
          breadcrumbPath: [],
        },
        component: () => import('../components/resource/Resources.vue'),
      },
      {
        name: 'ServicesAdd',
        path: 'services-add',
        meta: {
          title: 'Services Add',
          requiresAuth: true,
          authorize: ['provider'],
        },
        component: () => import('../components/add-resource/ResourceSettings.vue'),
      },
      {
        name: 'ServicesEdit',
        path: 'services/edit',
        meta: {
          title: 'Services Edit',
          requiresAuth: true,
          authorize: ['provider'],
          // breadcrumbPath: [
          //   {
          //     text: 'Services',
          //     exact: true,
          //     to: {
          //       name: 'Services',
          //     },
          //   },
          //   {
          //     text: 'Service Name',
          //   },
          // ],
        },
        component: () => import('../components/add-resource/ResourceSettings.vue'),
      },
      {
        name: 'OverviewService',
        path: 'service/overview/:id',
        meta: {
          title: 'Overview Service',
          requiresAuth: true,
          authorize: ['super-admin', 'provider'],
        },
        component: () => import('../components/resource/OverviewService.vue'),
      },
      {
        name: 'OverviewProvider',
        path: 'provider-overview/:id',
        meta: {
          title: 'Overview Provider',
          requiresAuth: true,
          authorize: ['super-admin', 'provider'],
        },
        component: () => import('../components/provider/OverviewProvider.vue'),
      },
      {
        name: 'EditProvider',
        path: 'edit-provider/:id',
        meta: {
          title: 'EditProvider',
          requiresAuth: true,
          authorize: ['super-admin', 'provider'],
        },
        component: () => import('../components/provider/EditProvider.vue'),
      },
      // {
      //   name: 'ServicesOverview',
      //   path: 'services/:id',
      //   meta: {
      //     title: 'Service Overview',
      //     requiresAuth: true,
      //     authorize: ['provider'],
      //     breadcrumbPath: [
      //       {
      //         text: 'Services',
      //         exact: true,
      //         to: {
      //           name: 'Services',
      //         },
      //       },
      //       {
      //         text: 'Service Name',
      //       },
      //     ],
      //   },
      //   component: () => import('../components/marketplace/MarketplaceResource.vue'),
      // },
      {
        name: 'EquipmentAdd',
        path: 'equipment-add',
        meta: {
          title: 'Equipment Add',
          requiresAuth: true,
          authorize: ['provider'],
        },
        component: () => import('../components/add-equipment/AddEquipment.vue'),
      },
      {
        name: 'AddPatent',
        path: 'patent-add',
        meta: {
          title: 'Patent Add',
          requiresAuth: true,
          authorize: ['provider'],
        },
        component: () => import('../components/add-patent/AddPatent.vue'),
      },
      {
        name: 'Patents',
        path: 'patents',
        meta: {
          title: 'Patents',
          requiresAuth: true,
          authorize: ['provider', 'super-admin'],
        },
        component: () => import('../components/patents/Patents.vue'),
      },
      {
        name: 'EditPatent',
        path: 'edit-patent/:id',
        meta: {
          title: 'Edit Patent',
          requiresAuth: true,
          authorize: ['super-admin', 'provider'],
        },
        component: () => import('../components/patents/EditPatent.vue'),
      },
      {
        name: 'OverviewPatent',
        path: 'patent/overview/:id',
        meta: {
          title: 'Overview Patent',
          requiresAuth: true,
          authorize: ['super-admin', 'provider'],
        },
        component: () => import('../components/patents/OverviewPatent.vue'),
      },
      {
        name: 'AddHostingInstitution',
        path: 'hosting-institution-add',
        meta: {
          title: 'Hosting Instituion Add',
          requiresAuth: true,
          authorize: ['super-admin', 'institution-representative'],
        },
        component: () => import('../components/add-hosting/AddHostingInstitution.vue'),
      },
      {
        name: 'EditHostingInstitution',
        path: 'edit-hosting-institution/:id',
        meta: {
          title: 'Edit Hosting Institution',
          requiresAuth: true,
          authorize: ['super-admin', 'institution-representative', 'provider'],
        },
        component: () => import('../components/hosting-institution/EditHostingInstitution.vue'),
      },
      {
        name: 'HostingRepresentativeMyResources',
        path: 'hosting-institutions-resources',
        meta: {
          title: 'Resources',
          requiresAuth: true,
          authorize: ['institution-representative'],
        },
        component: () =>
          import('../components/hosting-institution/HostingRepresentativeMyResources.vue'),
      },
      {
        name: 'OverviewHostingInstitution',
        path: 'hosting-institution/overview/:id',
        meta: {
          title: 'Overview Hosting Institution',
          requiresAuth: true,
          authorize: ['super-admin', 'institution-representative'],
        },
        component: () => import('../components/hosting-institution/OverviewHostingInstitution.vue'),
      },
      {
        name: 'HostingInstitutions',
        path: 'all-hosting-institutions',
        meta: {
          title: 'Hosting Institutions',
          requiresAuth: true,
          authorize: ['super-admin', 'provider'],
          breadcrumbPath: [],
        },
        component: () => import('../components/hosting-institution/HostingInstitutions.vue'),
      },
      {
        name: 'EditHostingInstitutionsMembers',
        path: 'all-hosting-institutions/:id/members',
        meta: {
          title: 'EditHostingInstitutionsMembers',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/provider-member/Members.vue'),
      },
      {
        name: 'AdminMembersOfInstitutions',
        path: 'hosting-institution/:id/members',
        meta: {
          title: 'Members Of Institution',
          requiresAuth: true,
          authorize: ['provider'],
        },
        component: () => import('../components/provider-member/AdminMembersOfInstitutions.vue'),
      },
      {
        name: 'AddProvider',
        path: 'add-provider',
        meta: {
          title: 'Add Provider',
          requiresAuth: true,
          authorize: ['provider'],
        },
        component: () => import('../components/provider/AddProvider.vue'),
      },
      {
        name: 'Equipment',
        path: 'equipment',
        meta: {
          title: 'Equipment',
          requiresAuth: true,
          authorize: ['provider', 'super-admin'],
          breadcrumbPath: [],
        },
        component: () => import('../components/equipment/Equipment.vue'),
      },
      {
        name: 'EditEquipment',
        path: 'equipment/edit/:id',
        meta: {
          title: 'Edit Equipment',
          requiresAuth: true,
          authorize: ['super-admin', 'provider'],
        },
        component: () => import('../components/equipment/EditEquipment.vue'),
      },
      {
        name: 'OverviewEquipment',
        path: 'equipment/overview/:id',
        meta: {
          title: 'Overview Equipment',
          requiresAuth: true,
          authorize: ['super-admin', 'provider'],
        },
        component: () => import('../components/equipment/OverviewEquipment.vue'),
      },
      {
        name: 'Notifications',
        path: 'notifications',
        meta: {
          title: 'Notifications',
          breadcrumbPath: [
            {
              text: 'Dashboard',
              disabled: false,
              href: 'dashboard',
            },
            {
              text: 'Notifications',
              disabled: true,
              href: 'notifications',
            },
          ],
          requiresAuth: true,
        },
        component: () => import('../components/notifications/Notifications.vue'),
      },
      {
        name: 'PendingRegistration',
        path: 'pending-registration',
        meta: {
          title: 'Pending Registration',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/pending-registration/PendingRegistration.vue'),
      },
      {
        name: 'ResearcherMyCollection',
        path: 'my-collections',
        meta: {
          title: 'My Orders',
          requiresAuth: true,
          authorize: ['researcher'],
          breadcrumbPath: [],
        },
        component: () => import('../components/researcher/ResearcherMyCollection.vue'),
      },
      {
        name: 'MyFavorites',
        path: 'my-favorites',
        meta: {
          title: 'My Favorites',
          requiresAuth: true,
          authorize: ['researcher', 'provider', 'institution-representative'],
          breadcrumbPath: [],
        },
        component: () => import('../components/my-favorites/MyFavorites.vue'),
      },
      {
        name: 'Suggested',
        path: 'suggested',
        meta: {
          title: 'Suggested Services',
          requiresAuth: true,
          authorize: ['researcher', 'provider', 'institution-representative'],
          breadcrumbPath: [],
        },
        component: () => import('../components/suggested/Suggested.vue'),
      },
      {
        name: 'Statistics',
        path: 'statistics',
        meta: {
          title: 'Statistics',
          requiresAuth: true,
          authorize: ['super-admin'],
        },
        component: () => import('../components/admin/statistics/Statistics.vue'),
      },
    ],
  },
  {
    path: '/authentication',
    component: () => import('../layouts/AuthLayout.vue'),
    children: [
      {
        name: 'SignUp',
        path: 'sign-up',
        meta: { title: 'Register' },
        component: () => import('../components/auth/SignUp.vue'),
      },
      {
        name: 'ForgotPassword',
        path: 'forgot-password',
        meta: { title: 'Forgot Password' },
        component: () => import('../components/auth/ForgotPassword.vue'),
      },
      {
        name: 'ResetPassword',
        path: 'reset-password',
        meta: { title: 'Reset Password' },
        component: () => import('../components/auth/ResetPassword.vue'),
      },
      {
        name: 'VerifyEmail',
        path: 'verify-email',
        meta: { title: 'Verify Email' },
        component: () => import('../components/auth/VerifyEmail.vue'),
      },
      {
        name: 'VerifyPublicContactEmail',
        path: 'verify-public-contact-email',
        meta: { title: 'Verify Email' },
        component: () => import('../components/auth/VerifyPublicContactEmail.vue'),
      },
      {
        name: 'FirstLogin',
        path: 'first-login',
        meta: { title: 'First Login' },
        component: () => import('../components/auth/FirstLogin.vue'),
      },
    ],
  },
  {
    path: '/orders-external',
    meta: {
      title: '',
      requiresAuth: false,
    },
    component: () => import('../layouts/PlainFormLayout.vue'),
    children: [
      {
        name: 'OrderAcceptedByProvider',
        path: 'accept-by-provider',
        meta: { title: 'Accept Order Form' },
        component: () => import('../components/order-external/OrderAcceptedByProvider.vue'),
      },
      {
        name: 'OrderRejectByProvider',
        path: 'reject-by-provider',
        meta: { title: 'Reject Order Form' },
        component: () => import('../components/order-external/OrderRejectByProvider.vue'),
      },
      {
        name: 'OrderAcceptedByResearcher',
        path: 'accept-by-researcher',
        meta: { title: 'Accept Offer' },
        component: () => import('../components/order-external/OrderAcceptedByResearcher.vue'),
      },
      {
        name: 'OrderRejectedByResearcher',
        path: 'reject-by-researcher',
        meta: { title: 'Reject Offer' },
        component: () => import('../components/order-external/OrderRejectedByResearcher.vue'),
      },
      {
        name: 'OrderEvaluationByResearcher',
        path: 'evaluation',
        meta: { title: 'Evaluate Service' },
        component: () => import('../components/order-external/OrderEvaluationByResearcher.vue'),
      },
      {
        name: 'OrderCompletedByProvider',
        path: 'completed-by-provider',
        meta: { title: 'Offer Completed' },
        component: () => import('../components/order-external/OrderCompletedByProvider.vue'),
      },
      {
        name: 'OrderInvalidatedByProvider',
        path: 'invalidated-by-provider',
        meta: { title: 'Offer Canceled' },
        component: () => import('../components/order-external/OrderInvalidatedByProvider.vue'),
      },
    ],
  },
  {
    path: '/page-401',
    name: 'Page401',
    component: () => import('../views/Page401.vue'),
  },
  {
    path: '/page-403',
    name: 'Page403',
    component: () => import('../views/Page403.vue'),
  },
  {
    path: '*',
    component: () => import('../views/Page404.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return new Promise(resolve => {
      setTimeout(() => {
        const appElement = document.getElementById('app');
        if (appElement) {
          appElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        resolve();
      }, 100);
    });
  },
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  // Title
  let globalTitle = process.env.VUE_APP_TITLE;
  if (to.meta.title) {
    document.title = to.meta.title + ' · ' + globalTitle;
  } else {
    document.title = globalTitle;
  }
  console.debug('Is keycloak authenticated: ' + Vue.$keycloak.authenticated);
  console.debug('Path: ' + to.path);
  //console.log('Path name: ' + to.name);
  console.debug('Page requires auth: ' + requiresAuth);
  if (Vue.$keycloak.hasRealmRole('default-roles-quarkus') && to.name != 'FirstLogin') {
    return next({ name: 'FirstLogin' });
  }
  if (to.path == '/' && Vue.$keycloak.authenticated) {
    next();
  } else if (
    to.name == 'Dashboard' &&
    Vue.$keycloak.authenticated &&
    Vue.$keycloak.hasRealmRole('researcher')
  ) {
    const selectedCatalogue = 'Browse the Catalogue of Services';
    const routePath = '/marketplace/services';
    next({
      path: routePath,
      query: { selectedCatalogue },
    });
  } else if (requiresAuth) {
    // Get the actual url of the app, it's needed for Keycloak
    const basePath = window.location.origin.toString();
    console.debug('Base Path: ' + basePath + ' to.path: ' + to.path);
    if (!Vue.$keycloak.authenticated) {
      // The page is protected and the user is not authenticated. Force a login.
      Vue.$keycloak.login({ redirectUri: basePath + to.path });
    } else if (
      Vue.$keycloak.hasRealmRole('super-admin') ||
      Vue.$keycloak.hasRealmRole('provider') ||
      Vue.$keycloak.hasRealmRole('researcher') ||
      Vue.$keycloak.hasRealmRole('institution-representative')
    ) {
      // The user was authenticated
      Vue.$keycloak
        .updateToken()
        .then(() => {
          next();
        })
        .catch(err => {
          console.error(err);
        });
    } else {
      // The user was authenticated, but did not have the correct role
      // Redirect to an error page
      next({ name: 'Page401' });
    }
  } else {
    // This page did not require authentication
    console.log('This page did not require authentication');
    next();
  }
});

export default router;
